// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__3Rcnd","label":"PriceFilterPopup_label__2ugvi","labelSelected":"PriceFilterPopup_labelSelected__2gZ4a"};